import { ProductFilesTab } from './ProductFilesTab';

export default ProductFilesTab;



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductFilesTab/index.ts